import React ,{useState ,useEffect} from 'react'; 
import StepFooter from 'components/presenters/footer/StepFooter'
import imagesbasic from 'images/imagesbasic.png'
import appInfoContainer from 'auth/appInfoContainer'
import { compressImage } from 'utils/utils.js';
import {Fitgrouparea, Imgtit, Titbar, Dot, Fileinput,FitChangeinner, Fitimages, Groupname, Fitinput, Fitlabel, Fitimg, Fitxt, PreviewImg, Subtit} from './style';

export default function ProjectSettingCoverTitleStep({grouProjectInfo,subtit,marginTop,titname,paddingBottom,placeholder,updateNext,projectImg,setProjectImg,projectTitle,setProjectTitle,isInitCoverImg,setIsInitCoverImg,initCoverImg}) {
    const [next ,setNext] = useState(false);
    const projectImgChange = async (e) =>{ 
        try{
            let imgFile = e.target.files[0];
            let compressedImg = await compressImage(imgFile)
            setProjectImg(compressedImg); 
            if(setIsInitCoverImg)
            {
                setIsInitCoverImg(false);
            }
        } 
        catch(err)
        {
            alert("이미지 처리를 실패했습니다.");
            console.log(err);
        }
     }
    const projectTitleChange = (e) => { setProjectTitle(e.target.value); }
    
    const projectImgVaildate = () =>{ return projectImgChange.length === 1};
    const projectTitleVaildate = () =>{ return projectTitle.length > 2};

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(()=>{
        if(( isInitCoverImg || (projectImg && projectImgVaildate())) && projectTitleVaildate())
                setNext(true);
        else
            setNext(false);
    },[projectImg,projectTitle]);
     
    let previewImg = [];

    if(projectImg)
    {
        previewImg.push(<Fitimages key={`group-project-setting-cover-img`}><PreviewImg src={URL.createObjectURL(projectImg)} /></Fitimages>);
    }
    else if(isInitCoverImg)
    {
        let coverImgSrc = appInfoContainer.imagePath +"/group_project_cover_img/"+initCoverImg;
        previewImg.push(<Fitimages key={`group-project-setting-cover-img`}><PreviewImg src={coverImgSrc} /></Fitimages>);
    }


    return(
        <Fitgrouparea>
            <FitChangeinner>
                <Titbar>
                    <Imgtit>대표 이미지 </Imgtit> 
                    {
                        (projectImg || isInitCoverImg) ?
                        <Dot> <Fileinput type="file" onChange={projectImgChange} /></Dot>
                        :
                        null
                    }
                </Titbar>
            </FitChangeinner>
            {
                (projectImg || isInitCoverImg) ?
                ( 
                    previewImg
                )
                :
                (
                    <Fitimages>
                        <Fitinput type="file" id="filefic" onChange={projectImgChange}></Fitinput>
                        <Fitlabel htmlFor="filefic"> 
                            <Fitimg><img src={imagesbasic} alt={'group project cover'} /></Fitimg>
                            <Fitxt>모임을 대표하는<br></br>
                                    이미지를 넣어주세요</Fitxt>
                        </Fitlabel>
                    </Fitimages>
                )
            }
            

            <Titbar><Imgtit>{titname} </Imgtit></Titbar>
                <Subtit marginTop={marginTop} paddingBottom={paddingBottom}>{subtit}</Subtit>
            <Groupname type="text"  placeholder={placeholder}  onChange={projectTitleChange} value={projectTitle}/>

            {
                next ?
                <StepFooter
                    text={"1 / 5"}
                    color={"#7f7f7f"} 
                    position={"fixed"}
                    prevdisplay={"flex"}
                    nextdisplay={"flex"}
                    updateNext={updateNext}
                    next={next}
                />
            :
            <StepFooter
                    text={"1 / 5"}
                    color={"#7f7f7f"} 
                    position={"fixed"}
                    prevdisplay={"flex"}
                    nextdisplay={"flex"}
                    updateNext={updateNext}
                    bg={"#d8d8d8"}
                    next={false}
                />
            }
        </Fitgrouparea>
    );
}
